import {DataSource} from '@angular/cdk/collections';
import {MatSort} from '@angular/material/sort';
import {ContactModel} from '@app/models/contact.model';
import {BehaviorSubject, merge, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

export class YellowPagesDatasource extends DataSource<any> {
  private readonly contactListChange = new BehaviorSubject([]);
  get contactList(): ContactModel[] {
    return this.contactListChange.value;
  }
  set contactList(list: ContactModel[]) {
    this.contactListChange.next(list);
  }

  constructor(private readonly sort: MatSort) {
    super();
  }

  connect(): Observable<ContactModel[]> {
    const displayDataChanges = [this.contactListChange, this.sort.sortChange];

    return merge(...displayDataChanges).pipe(
      map(() => {
        return this.getSortedData().slice();
      })
    );
  }

  disconnect() {}

  getSortedData(): ContactModel[] {
    const data = this.contactList.slice();
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      let propertyA: number | string | Date = '';
      let propertyB: number | string | Date = '';

      switch (this.sort.active) {
        case 'name':
          [propertyA, propertyB] = [a.name, b.name];
          break;
        case 'number':
          [propertyA, propertyB] = [a.phoneNumber, b.phoneNumber];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this.sort.direction === 'asc' ? 1 : -1);
    });
  }
}
